function isJsonObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false
  }
  const prototype = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

export function toPersistedJsonShape(value: unknown): unknown {
  if (Array.isArray(value)) {
    const items: ReadonlyArray<unknown> = value
    return Array.from(items, (item) =>
      item === undefined ? null : toPersistedJsonShape(item)
    )
  }
  if (!isJsonObject(value)) return value

  return Object.fromEntries(
    Object.entries(value)
      .filter(([, nested]) => nested !== undefined)
      .map(([key, nested]) => [key, toPersistedJsonShape(nested)])
  )
}
